<template>
  <div class="navbar-container d-flex content align-items-center just-sb ac">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex "
    >
      <!-- <div @click="back">Back</div>
      <div class="ft-18 fw-7">{{ $route.meta.pageTitle }}</div> -->

      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
    </div>

    <b-navbar-nav
      class="nav align-items-center ml-auto mcc-style-nav-link flex"
      style="gap:16px;"
    >
      <locale />
      <todo />
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <b-avatar
            v-if="userAllInfo.staffId"
            size="40"
            variant="light-primary"
            badge
            :src="avatar"
            class="badge-minimal"
            badge-variant="success"
          />
          <b-avatar
            v-else
            size="40"
            variant="light-primary"
            badge
            :src="userAllInfo.avatar"
            class="badge-minimal"
            badge-variant="success"
          />
          <div
            class="d-sm-flex d-none user-nav fd-column pd-lf8"
            style="font-size: 12px;"
          >
            <p class="user-name font-weight-bolder mb-0 fw-7 black-text">
              {{ filterName(userInfo.real_name) }}
            </p>
            <span class="user-status fw-5 gray-text ">{{
              userInfo.user_name
            }}</span>
          </div>
          <!-- :src="require('@/assets/images/avatars/13-small.png')" -->
        </template>

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="UserIcon"
            class="mr-50"
          />
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon
            size="16"
            icon="MailIcon"
            class="mr-50"
          />
          <span>Inbox</span>
        </b-dropdown-item> -->

        <b-dropdown-item
          link-class="d-flex align-items-center "
          @click="handlePhoto"
        >
          <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
          <span>{{ i18n('photo') }}</span>
        </b-dropdown-item>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="handleSign"
        >
          <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
          <span>{{ i18n('sign') }}</span>
        </b-dropdown-item>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="changePassword"
        >
          <feather-icon size="16" icon="LockIcon" class="mr-50" />
          <span>{{ i18n('password') }}</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="handleLogout"
        >
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>{{ i18n('logout') }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import Todo from '@/views/todo/index.vue'
import { mapGetters } from 'vuex'
import { password } from '@/@core/utils/validations/validations'

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    Locale,
    // Navbar Components
    DarkToggler,
    Todo,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'userAllInfo']),
    avatar() {
      return this.userAllInfo?.staffInfo?.photoAttach?.link || ''
    },
  },
  filter: {},
  mounted() {},
  methods: {
    filterName(e) {
      if (e) {
        if (e.length > 15) {
          return e.substring(0, 15) + '...'
        }
        return e
      }
      return ''
    },
    handleLogout() {
      // this.$confirm('是否退出系统, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // }).then(() => {
      //   this.$store.dispatch('LogOut').then(() => {
      //     this.$router.push({ path: '/login' })
      //   })
      // })
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push({ path: '/login' })
      })
    },
    changePassword() {
      this.$router.push({
        path: '/AccountSetting/index',
        query: {
          type: 'password',
        },
      })
    },
    handlePhoto() {
      this.$router.push({
        path: '/AccountSetting/index',
        query: {
          type: 'photo',
        },
      })
    },
    handleSign() {
      this.$router.push({
        path: '/AccountSetting/index',
        query: {
          type: 'sign',
        },
      })
    },
    back() {
      this.$router.back()
    },
    i18n(param) {
      return this.$t(`system.navbar.${param}`)
    },
  },
}
</script>
<style scoped>
.ac {
  width: 100%;
  .dropdown-toggle::after {
    display: none;
  }
}
</style>
